const paginationParams = {
  page: 1,
  per_page: 50,
  total: 0
}

export default paginationParams
